let id = 1;
const getUniqueId: () => number = () => id++;

export default getUniqueId;